/* globals angular */
(function(){
  'use strict';

  var packagesList = {
    template: require('./packages-list.html'),
    controller: 'PackagesListCtrl',
  };

  angular
    .module('mandaeApp')
    .component('packagesList', packagesList)
    .config(['$qProvider', '$stateProvider', function($qProvider, $stateProvider) {
      $qProvider.errorOnUnhandledRejections(false);
      $stateProvider
        // url will be app/historico/encomendas
        .state('packages-list', {
          parent: 'historico',
          url: '/ocorrencias',
          component: 'packagesList',
          params: {
            emAtraso: false,
            acoesPendentes: false,
          }
        });
    }]);

}());
